//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppHead',
  props: {
    headStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    headData: {
      type: [Number],
      default() {
        return null
      }
    },
    callBack: {
      type: Boolean,
      default() {
        return false
      }
    },
    backHref: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    className() {
      if (this.headData) {
        return `type${this.headData}`
      } else {
        return ''
      }
    }
  },
  mounted() {
  },
  methods: {
    back() {
      if (this.callBack) {
        this.$emit('back')
      } else {
        if (this.backHref) {
          this.$router.replace(this.backHref)
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/appHead.vue